import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'timerTransform',
  standalone: false
})
export class TimerPipe implements PipeTransform {
  public transform(value: number): string | number {
    const minutes: number = Math.floor(value / 60);
    if (minutes > 0) {
      return (
        `00${minutes}`.slice(-2) +
        ':' +
        `00${Math.floor(value - minutes * 60)}`.slice(-2)
      );
    }
    return value;
  }
}
